/**
 * Both guarded so a plain Node test can import anything that reaches config:
 * `window` and `import.meta.env` are Vite/browser facts, not language ones.
 */
const SEARCH = globalThis.location?.search ?? "";
const ENV: Record<string, string | undefined> =
  (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};

export const clientConfig = {
  // ?server=ws://host:port lets QA point a build at another server without a rebuild.
  serverUrl:
    new URLSearchParams(SEARCH).get("server") ?? ENV.VITE_SERVER_URL ?? "ws://localhost:2567",
  roomName: "concert",

  /**
   * 1-on-1 voice. Off unless `VITE_VOICE_ENABLED=1`.
   *
   * Off by default for three reasons that all point the same way. It is first
   * on the documented cut list (spec 8). There is no TURN relay, and without
   * one a call fails outright behind symmetric NAT, which is a real share of
   * Indian mobile carriers — so for those fans the feature is a button that
   * does nothing and explains nothing. And the build spec lists voice chat
   * among the things this venue is not.
   *
   * The code is kept rather than deleted: it works on a good network, the
   * consent flow and the report path are built and tested, and turning it on
   * is one variable once a TURN server exists. Deleting it would make that a
   * rewrite instead.
   */
  voiceEnabled: (ENV.VITE_VOICE_ENABLED ?? "").trim() === "1",
};
